'use strict';

var recaptchaUtils = require('../recaptcha-utils');

var guestOrderLookup = {
    init: function () {
        recaptchaUtils.registerRecaptchaFormPassthrough('form.recaptcha-guest-order-lookup-form', '.recaptcha-submit', 'button.submit-requiring-recaptcha');
    }
}

module.exports = guestOrderLookup;
